import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  GetLeadDetailsByEmployee,
  AddLead,
  AddLeadRequest,
  LeadRecord,
  EmployeeInfo,
  ResetAddLead,
  ClearLeadError
} from './LeadAction';

const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');

  @keyframes shimmer {
    0%   { background-position: -200% center; }
    100% { background-position:  200% center; }
  }
  @keyframes fadeSlideUp {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes orbPulse1 {
    0%,100% { transform: scale(1) translate(0,0); opacity:.45; }
    50%     { transform: scale(1.1) translate(20px,-15px); opacity:.65; }
  }
  @keyframes orbPulse2 {
    0%,100% { transform: scale(1) translate(0,0); opacity:.35; }
    50%     { transform: scale(1.07) translate(-20px,15px); opacity:.55; }
  }
  @keyframes cardIn {
    from { opacity:0; transform: translateY(20px) scale(.98); }
    to   { opacity:1; transform: translateY(0) scale(1); }
  }
  @keyframes particle {
    0%   { transform: translateY(0) translateX(0); opacity:0; }
    10%  { opacity:.8; }
    90%  { opacity:.3; }
    100% { transform: translateY(-110vh) translateX(var(--dx)); opacity:0; }
  }
  @keyframes fadeSlideIn {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes slideInRight {
    from { transform: translateX(100%); opacity: 0; }
    to   { transform: translateX(0);   opacity: 1; }
  }

  .lm-particle {
    position: fixed;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(0,220,210,.8) 0%, rgba(0,160,190,.3) 60%, transparent 100%);
    animation: particle var(--dur) var(--delay) ease-in infinite;
    pointer-events: none;
    z-index: 0;
  }

  .lm-page {
    font-family: 'DM Sans', sans-serif;
    min-height: 100vh;
    background: linear-gradient(145deg,#04111a 0%,#091e2e 35%,#0d2840 60%,#06141e 100%);
    position: relative;
    overflow-x: hidden;
    color: #e8f4f6;
  }
  .lm-grid-bg {
    position: fixed;
    inset: 0;
    pointer-events: none;
    background-image:
      linear-gradient(rgba(0,210,200,.025) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0,210,200,.025) 1px, transparent 1px);
    background-size: 55px 55px;
    z-index: 0;
  }
  .lm-content {
    position: relative;
    z-index: 1;
    padding: 12px 12px 24px;
  }
  .lm-breadcrumb {
    padding: 10px 16px;
    font-size: 13px;
    background: rgba(0,0,0,.25);
    border-bottom: 1px solid rgba(0,210,200,.12);
    backdrop-filter: blur(8px);
    position: sticky;
    top: 0;
    z-index: 10;
    animation: fadeSlideUp .4s ease both;
  }
  .lm-breadcrumb-link { color: #00d2c8; cursor: pointer; transition: color .2s; }
  .lm-breadcrumb-link:hover { color: #40e8e0; }
  .lm-breadcrumb-sep { margin: 0 6px; color: rgba(0,210,200,.4); }
  .lm-breadcrumb-current { color: #7ab0b8; font-weight: 600; }

  .lm-section {
    border: 1px solid rgba(0,210,200,.18);
    margin-bottom: 8px;
    border-radius: 12px;
    overflow: hidden;
    background: linear-gradient(160deg, rgba(12,28,45,.96) 0%, rgba(7,18,32,.98) 100%);
    box-shadow: 0 4px 24px rgba(0,0,0,.5), 0 0 40px rgba(0,150,160,.05), inset 0 1px 0 rgba(0,210,200,.07);
    animation: cardIn .5s cubic-bezier(.16,1,.3,1) both;
    backdrop-filter: blur(12px);
  }
  .lm-shimmer-line {
    height: 2px;
    background: linear-gradient(90deg, transparent, #00d2c8, #48cae4, #00d2c8, transparent);
    background-size: 200% auto;
    animation: shimmer 3.5s linear infinite;
  }
  .lm-section-header {
    background: linear-gradient(90deg, rgba(0,160,155,.28) 0%, rgba(0,120,175,.18) 100%);
    border-bottom: 1px solid rgba(0,210,200,.15);
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .lm-section-title {
    font-size: 13px;
    font-weight: 700;
    color: #e8f4f6;
    letter-spacing: .03em;
  }
  .lm-section-body {
    padding: 14px 16px;
    background: #c5d7d5;
  }

  /* ── Toolbar ── */
  .lm-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
    flex-wrap: wrap;
  }
  .lm-add-btn {
    padding: 8px 18px;
    background: rgba(0,160,155,.25);
    border: 1px solid rgba(0,210,200,.35);
    border-radius: 20px;
    color: #004a46;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: all .2s;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: 'DM Sans', sans-serif;
    white-space: nowrap;
  }
  .lm-add-btn:hover {
    background: rgba(0,160,155,.4);
    box-shadow: 0 0 12px rgba(0,160,155,.3);
  }
  .lm-add-btn:disabled { opacity: .5; cursor: not-allowed; }
  .lm-search-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255,255,255,.52);
    border: 1px solid rgba(0,100,95,.28);
    border-radius: 20px;
    padding: 6px 14px;
    flex: 1;
    max-width: 460px;
    margin-left: auto;
  }
  .lm-search-input {
    border: none;
    outline: none;
    font-family: 'DM Sans', sans-serif;
    font-size: 12.5px;
    color: #0b2d30;
    background: transparent;
    width: 100%;
  }
  .lm-search-input::placeholder { color: rgba(10,55,58,.45); }

  /* ── Filter Bar ── */
  .lm-filter-bar {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr auto;
    gap: 12px;
    margin-bottom: 16px;
    align-items: end;
    background: rgba(0,0,0,.28);
    padding: 14px 16px;
    border-radius: 12px;
    border: 1px solid rgba(0,210,200,.15);
    backdrop-filter: blur(8px);
  }
  @media (max-width: 1400px) {
    .lm-filter-bar {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    .lm-clear-filters { grid-column: 1 / -1; justify-content: center; }
  }
  @media (max-width: 1000px) {
    .lm-filter-bar { grid-template-columns: 1fr 1fr 1fr; }
  }
  @media (max-width: 768px) {
    .lm-filter-bar { grid-template-columns: 1fr 1fr; }
  }
  @media (max-width: 560px) {
    .lm-filter-bar { grid-template-columns: 1fr; }
  }
  .lm-filter-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
  }
  .lm-filter-label {
    font-size: 10px;
    font-weight: 700;
    color: #00d2c8;
    letter-spacing: .9px;
    text-transform: uppercase;
    padding-left: 2px;
    white-space: nowrap;
  }
  .lm-filter-select,
  .lm-filter-input {
    background: rgba(255,255,255,.88);
    border: 1px solid rgba(0,110,105,.3);
    border-radius: 8px;
    padding: 0 12px;
    font-size: 12px;
    font-family: 'DM Sans', sans-serif;
    color: #0b2d30;
    outline: none;
    cursor: pointer;
    transition: border-color .2s, box-shadow .2s, background .2s;
    font-weight: 500;
    height: 34px;
    box-sizing: border-box;
    width: 100%;
    appearance: none;
    -webkit-appearance: none;
  }
  .lm-filter-select {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%230b2d30' stroke-width='2.5'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    padding-right: 30px;
  }
  .lm-filter-select:focus,
  .lm-filter-input:focus {
    border-color: #00d2c8;
    box-shadow: 0 0 0 2px rgba(0,210,200,.18);
    background: #fff;
  }
  .lm-clear-filters {
    background: rgba(0,80,75,.3);
    border: 1px solid rgba(0,210,200,.4);
    border-radius: 8px;
    padding: 0 16px;
    height: 34px;
    font-size: 11.5px;
    font-weight: 700;
    color: #00d2c8;
    cursor: pointer;
    transition: all .2s;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-family: 'DM Sans', sans-serif;
    white-space: nowrap;
    align-self: end;
    letter-spacing: .02em;
  }
  .lm-clear-filters:hover {
    background: rgba(0,110,105,.45);
    box-shadow: 0 0 10px rgba(0,210,200,.2);
    transform: translateY(-1px);
  }
  .lm-clear-filters:disabled {
    opacity: .35;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  /* ── Table ── */
  .lm-table-wrap {
    border-radius: 10px;
    overflow: auto;
    border: 1px solid rgba(0,110,105,.22);
    background: rgba(255,255,255,.6);
  }
  .lm-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    min-width: 1900px;
  }
  .lm-table th {
    text-align: left;
    padding: 10px 10px;
    color: #1a5558;
    font-weight: 700;
    border-bottom: 1px solid rgba(0,110,105,.25);
    background: rgba(255,255,255,.25);
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: .04em;
    white-space: nowrap;
  }
  .lm-table th.sortable { cursor: pointer; user-select: none; }
  .lm-table th.sortable:hover { background: rgba(255,255,255,.35); }
  .lm-table td {
    padding: 9px 10px;
    color: #0b2d30;
    border-bottom: 1px solid rgba(0,110,105,.1);
    vertical-align: middle;
    background: rgba(255,255,255,.4);
  }
  .lm-trow { animation: fadeSlideIn .3s ease both; }
  .lm-trow:hover td { background: rgba(255,255,255,.65); }

  /* ── Badges ── */
  .lm-badge {
    border: 1.5px solid;
    border-radius: 20px;
    padding: 2px 9px;
    font-size: 11px;
    font-weight: 600;
    background: rgba(255,255,255,.45);
    display: inline-block;
    white-space: nowrap;
  }
  .lm-status-active   { border-color: rgba(0,120,110,.5);  color: #094a47; }
  .lm-status-inactive { border-color: rgba(180,40,40,.4);  color: #7a1010; }
  .lm-type-cold { border-color: rgba(0,100,180,.5);   color: #003f80; }
  .lm-type-warm { border-color: rgba(200,100,0,.5);   color: #7a3e00; }
  .lm-type-hot  { border-color: rgba(180,30,30,.5);   color: #7a0f0f; }
  .lm-booking-confirmed { border-color: rgba(0,130,80,.5);   color: #004a2a; }
  .lm-booking-pending   { border-color: rgba(160,120,0,.5);  color: #5e4500; }
  .lm-booking-cancelled { border-color: rgba(180,40,40,.4);  color: #7a1010; }
  .lm-booking-type-done { border-color: rgba(0,130,80,.5); background: rgba(0,200,100,.15); color: #004a2a; }
  .lm-booking-type-pending { border-color: rgba(230,138,46,.5); background: rgba(230,138,46,.1); color: #b45f1b; }
  .dynamic-data-done { background: rgba(0,130,80,.1); padding: 4px 8px; border-radius: 6px; font-weight: 600; color: #004a2a; display: inline-block; }
  .dynamic-data-pending { background: rgba(230,138,46,.1); padding: 4px 8px; border-radius: 6px; font-weight: 500; color: #b45f1b; display: inline-block; }

  /* ── Icon Buttons ── */
  .lm-icon-btn {
    background: rgba(255,255,255,.4);
    border: 1px solid rgba(0,110,105,.25);
    border-radius: 6px;
    padding: 5px 7px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    color: #1a5558;
    transition: all .15s;
    font-family: inherit;
    font-size: 12px;
  }
  .lm-icon-btn:hover { background: rgba(255,255,255,.6); }
  .lm-icon-btn.del:hover { background: rgba(180,40,40,.2); color: #7a1010; border-color: rgba(180,40,40,.3); }
  .lm-icon-btn:disabled { opacity: .5; cursor: not-allowed; }

  .lm-sort-icon {
    background: rgba(0,110,105,.2);
    border-radius: 3px;
    padding: 0px 4px;
    font-size: 10px;
    color: #1a5558;
    margin-left: 4px;
  }

  /* ── Pagination ── */
  .lm-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 12px;
    font-size: 12px;
    color: #2a7070;
    font-weight: 600;
    flex-wrap: wrap;
  }
  .lm-pg-select {
    border: 1px solid rgba(0,110,105,.3);
    border-radius: 6px;
    padding: 3px 7px;
    font-size: 12px;
    font-family: 'DM Sans', sans-serif;
    color: #094a47;
    background: rgba(255,255,255,.5);
    cursor: pointer;
    outline: none;
  }
  .lm-action-btn {
    padding: 4px 10px;
    background: rgba(0,110,105,.2);
    border: 1px solid rgba(0,110,105,.3);
    border-radius: 20px;
    color: #094a47;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all .2s;
    display: inline-flex;
    align-items: center;
    font-family: 'DM Sans', sans-serif;
  }
  .lm-action-btn:hover { background: rgba(0,110,105,.35); }
  .lm-action-btn:disabled { opacity: .4; cursor: default; }

  /* ── Modal ── */
  .lm-overlay {
    position: fixed;
    inset: 0;
    background: rgba(4,17,26,.85);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .lm-modal {
    background: linear-gradient(160deg, #0c1c2d 0%, #071220 100%);
    border: 1px solid rgba(0,210,200,.2);
    border-radius: 14px;
    width: 600px;
    max-width: 85vw;
    max-height: 90vh;
    box-shadow: 0 24px 64px rgba(0,0,0,.6), 0 0 40px rgba(0,150,160,.08);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .lm-modal-header {
    background: linear-gradient(90deg, rgba(0,160,155,.28) 0%, rgba(0,120,175,.18) 100%);
    border-bottom: 1px solid rgba(0,210,200,.15);
    padding: 14px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
  }
  .lm-modal-title { color: #e8f4f6; font-size: 14px; font-weight: 700; }
  .lm-modal-body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    background: rgba(197,215,213,.95);
    overflow-y: auto;
    max-height: calc(90vh - 120px);
  }
  .lm-modal-footer {
    padding: 14px 20px;
    border-top: 1px solid rgba(0,110,105,.2);
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    background: rgba(0,0,0,.2);
    flex-shrink: 0;
  }
  .lm-form-row { display: flex; flex-direction: column; gap: 5px; }
  .lm-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
  .lm-form-grid-3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 14px; }
  @media (max-width: 600px) {
    .lm-form-grid, .lm-form-grid-3 { grid-template-columns: 1fr; }
  }
  .lm-label {
    font-size: 10.5px;
    color: #1a5558;
    font-weight: 700;
    letter-spacing: .02em;
    text-transform: uppercase;
  }
  .lm-input {
    width: 100%;
    padding: 6px 10px;
    border: 1px solid rgba(0,100,95,.28);
    border-radius: 7px;
    font-size: 12px;
    height: 30px;
    box-sizing: border-box;
    background: rgba(255,255,255,.7);
    color: #0b2d30;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    transition: border-color .2s, box-shadow .2s;
    outline: none;
  }
  .lm-input:focus {
    border-color: #007a74;
    box-shadow: 0 0 0 3px rgba(0,120,115,.2);
    background: rgba(255,255,255,.9);
  }
  textarea.lm-input { height: 64px; resize: vertical; padding-top: 8px; }
  select.lm-input { cursor: pointer; }
  .lm-cancel-btn {
    padding: 8px 18px;
    background: rgba(255,255,255,.1);
    border: 1px solid rgba(255,255,255,.2);
    border-radius: 7px;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: #7ab0b8;
    cursor: pointer;
    transition: all .2s;
  }
  .lm-cancel-btn:hover { background: rgba(255,255,255,.2); }
  .lm-save-btn {
    padding: 8px 20px;
    background: rgba(0,160,155,.3);
    border: 1px solid rgba(0,210,200,.4);
    border-radius: 7px;
    font-family: 'DM Sans', sans-serif;
    font-size: 13px;
    font-weight: 700;
    color: #c6d3d2;
    cursor: pointer;
    transition: all .2s;
  }
  .lm-save-btn:hover { background: rgba(0,160,155,.45); box-shadow: 0 0 12px rgba(0,160,155,.3); }
  .lm-save-btn:disabled { opacity: .5; cursor: not-allowed; }

  .lm-college-row { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; }
  .lm-college-num { font-size: 10px; font-weight: 700; color: #1a5558; min-width: 18px; text-align: right; }

  /* ── Toast ── */
  .lm-toast {
    position: fixed;
    top: 30px;
    right: 30px;
    padding: 16px 28px;
    border-radius: 50px;
    box-shadow: 0 10px 30px rgba(0,0,0,.3), 0 0 0 1px rgba(0,210,200,.3);
    z-index: 9999;
    animation: slideInRight .3s cubic-bezier(.16,1,.3,1);
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 300px;
    pointer-events: none;
    color: white;
  }
  .lm-toast.error   { background: #b53b3b; border-left: 5px solid #ff9f9f; }
  .lm-toast.success { background: #0c8c7c; border-left: 5px solid #00ffd0; }

  /* ── Delete Confirm ── */
  .lm-delete-confirm {
    background: rgba(180,40,40,.1);
    border: 1px solid rgba(180,40,40,.3);
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    margin: 10px 0;
  }
  .lm-delete-confirm p { color: #7a1010; font-size: 14px; margin-bottom: 15px; }
  .lm-delete-confirm-buttons { display: flex; gap: 10px; justify-content: center; }
  .lm-confirm-delete-btn {
    background: rgba(180,40,40,.2);
    border: 1px solid rgba(180,40,40,.4);
    border-radius: 20px;
    padding: 6px 16px;
    color: #7a1010;
    font-weight: 600;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
  }
  .lm-confirm-delete-btn:hover { background: rgba(180,40,40,.3); }
  .lm-cancel-delete-btn {
    background: rgba(255,255,255,.2);
    border: 1px solid rgba(255,255,255,.3);
    border-radius: 20px;
    padding: 6px 16px;
    color: #7ab0b8;
    font-weight: 600;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
  }
  .lm-cancel-delete-btn:hover { background: rgba(255,255,255,.3); }

  select option {
    background: #0c1c2d;
    color: #e8f4f6;
    padding: 12px;
  }
  select::-webkit-scrollbar { width: 8px; background: #0c1c2d; }
  select::-webkit-scrollbar-thumb { background: rgba(0,210,200,.3); border-radius: 4px; }
  select::-webkit-scrollbar-thumb:hover { background: rgba(0,210,200,.5); }
  
  .disabled-field {
    opacity: 0.6;
    background: rgba(255,255,255,.4);
    cursor: not-allowed;
  }
`;
const PARTICLES = Array.from({ length: 18 }, (_, i) => ({
  id: i,
  size: Math.random() * 4 + 2,
  left: Math.random() * 100,
  dur: Math.random() * 12 + 8,
  delay: Math.random() * 10,
  dx: (Math.random() - 0.5) * 100,
}));

const LEAD_SOURCES = ['Website', 'Referral', 'Social Media', 'Walk-in', 'Email Campaign', 'Phone Inquiry', 'Exhibition', 'Agent'];
const COURSES = ['MBA', 'BBA', 'B.Tech', 'M.Tech', 'MBBS', 'BDS', 'LLB', 'B.Sc', 'M.Sc', 'BCA', 'MCA', 'B.Com', 'M.Com', 'BArch'];
const LOCATIONS = ['Mumbai', 'Delhi', 'Bangalore', 'Pune', 'Chennai', 'Hyderabad', 'Kolkata', 'Ahmedabad', 'USA', 'UK', 'Canada', 'Australia'];
const BOOKING_TYPES = ['done', 'pending'];

interface Lead {
  id: number;
  leadId: number | null;
  clientName: string;
  clientParentName: string;
  clientEmail: string;
  clientPhone: string;
  leadSource: string;
  leadStatus: 'active' | 'inactive';
  leadType: 'cold' | 'warm' | 'hot';
  interestedCourse: string;
  preferredLocation: string;
  budget: number;
  preferredCollege1: string;
  preferredCollege2: string;
  preferredCollege3: string;
  followupTimeline: string;
  nextAction: string;
  lastRemarks: string;
  bookingStatus: 'confirmed' | 'pending' | 'cancelled';
  bookingType: string;
  expectedDate: string;
  visitDate: string;
  employeeCode: string;
}

interface Employee {
  ID: number;
  EmployeeID: number;
  EmployeeCode: string;
  EmployeeName: string;
  Email: string;
  MobileNumber: string;
  Department: string;
  Designation: string;
  EmploymentStatus: string;
  IsActive: boolean;
}

const EMPTY_FORM = {
  clientName: '',
  clientParentName: '',
  clientEmail: '',
  clientPhone: '',
  leadSource: '',
  leadStatus: 'active' as 'active' | 'inactive',
  leadType: 'cold' as 'cold' | 'warm' | 'hot',
  interestedCourse: '',
  preferredLocation: '',
  budget: 0,
  preferredCollege1: '',
  preferredCollege2: '',
  preferredCollege3: '',
  followupTimeline: '',
  nextAction: '',
  lastRemarks: '',
  bookingStatus: 'pending' as 'confirmed' | 'pending' | 'cancelled',
  bookingType: '',
  expectedDate: '',
  visitDate: '',
};

interface Props {
  GetLeadDetailsByEmployee: (employeeCode: string) => (dispatch: any) => Promise<any>;
  AddLead: (leadData: AddLeadRequest) => (dispatch: any) => Promise<any>;
  ResetAddLead: () => void;
  ClearLeadError: () => void;
  leads: any[];
  employeeInfo: EmployeeInfo | null;
  employees: Employee[];
  loading: boolean;
  error: any;
  manageStatus?: any;
  dispatch?: any;
}

interface State {
  leads: Lead[];
  search: string;
  page: number;
  rowsPerPage: number;
  sortAsc: boolean;
  showModal: boolean;
  editingLead: Lead | null;
  form: typeof EMPTY_FORM;
  employeeCode: string;
  employeeInfo: EmployeeInfo | null;
  employees: Employee[];
  isSaving: boolean;
  isDeleting: boolean;
  showToast: boolean;
  toastMessage: string;
  toastType: 'success' | 'error';
  showDeleteConfirm: boolean;
  deletingLead: Lead | null;
  roleCode: string | null;
  filterLeadName: string;
  filterInterestedCourse: string;
  filterBookingStatus: string;
  filterLeadStatus: string;
  filterBookingType: string;
}

class LeadManagementPage extends PureComponent<Props, State> {
  private toastTimeout: NodeJS.Timeout | null = null;

  constructor(props: Props) {
    super(props);
    const employeeCode = sessionStorage.getItem('employeeCode') || 'EMP001';
    const roleCode = sessionStorage.getItem('RoleCode');

    this.state = {
      leads: [],
      search: '',
      page: 0,
      rowsPerPage: 10,
      sortAsc: true,
      showModal: false,
      editingLead: null,
      form: { ...EMPTY_FORM },
      employeeCode,
      employeeInfo: null,
      employees: props.employees || [],
      isSaving: false,
      isDeleting: false,
      showToast: false,
      toastMessage: '',
      toastType: 'success',
      showDeleteConfirm: false,
      deletingLead: null,
      roleCode,
      filterLeadName: '',
      filterInterestedCourse: '',
      filterBookingStatus: '',
      filterLeadStatus: '',
      filterBookingType: '',
    };
  }

  componentDidMount() { this.fetchLeads(); }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevProps.employees !== this.props.employees && this.props.employees) {
      this.setState({ employees: this.props.employees });
    }
    if (prevState.employeeCode !== this.state.employeeCode) {
      this.fetchLeads();
    }
    if (prevProps.leads !== this.props.leads && this.props.leads) {
      this.populateLeadsFromProps();
    }
    if (prevProps.employeeInfo !== this.props.employeeInfo && this.props.employeeInfo) {
      this.setState({ employeeInfo: this.props.employeeInfo });
    }
    if (prevProps.manageStatus !== this.props.manageStatus && this.props.manageStatus) {
      const status = this.props.manageStatus;
      const isSuccess = status.success === true || status.Success === true || status.out_success === true;
      if (isSuccess) {
        const apiMessage = status.message || status.Message || status.out_message ||
          (status.operation === 'UPDATE' ? 'Lead updated successfully!' :
           status.operation === 'DELETE' ? 'Lead deleted successfully!' :
           status.operation === 'INSERT' ? 'Lead added successfully!' : 'Operation completed successfully!');
        this.showToast('success', apiMessage);
        const operation = status.operation || (status.indicator === 'I' ? 'INSERT' : status.indicator === 'U' ? 'UPDATE' : status.indicator === 'D' ? 'DELETE' : '');
        if (operation !== 'DELETE') { this.closeModal(); }
        else { this.setState({ showDeleteConfirm: false, deletingLead: null }); }
        this.setState({ isSaving: false, isDeleting: false });
        setTimeout(() => { this.fetchLeads(); }, 500);
      } else if (status.error) {
        const errorMessage = status.error?.message || status.message || status.Message || 'Operation failed';
        this.showToast('error', errorMessage);
        this.setState({ isSaving: false, isDeleting: false });
      }
    }
    if (prevProps.error !== this.props.error && this.props.error) {
      if (this.props.error && typeof this.props.error === 'object') {
        const errorMessage = this.props.error.message || 'An error occurred';
        if (errorMessage.includes('connect') || errorMessage.includes('network')) {
          this.showToast('error', 'Failed to connect to server. Please check if backend is running.');
        }
      }
      this.setState({ isSaving: false, isDeleting: false });
    }
  }

  componentWillUnmount() {
    if (this.toastTimeout) clearTimeout(this.toastTimeout);
    this.props.ClearLeadError();
    this.props.ResetAddLead();
  }

  showToast = (type: 'success' | 'error', message: string) => {
    if (this.toastTimeout) clearTimeout(this.toastTimeout);
    this.setState({ showToast: true, toastType: type, toastMessage: message });
    this.toastTimeout = setTimeout(() => { this.setState({ showToast: false }); }, 4000);
  };

  populateLeadsFromProps = () => {
    const { leads } = this.props;
    if (!leads || leads.length === 0) { this.setState({ leads: [] }); return; }
    const transformedLeads: Lead[] = leads.map((apiLead: any, index: number) => ({
      id: apiLead.id || apiLead.leadId || apiLead.lead_id || Date.now() + index,
      leadId: apiLead.leadId || apiLead.lead_id || apiLead.id,
      clientName: apiLead.clientName || apiLead.clientname || apiLead.client_name || '',
      clientParentName: apiLead.clientParentName || apiLead.clientparentname || apiLead.client_parent_name || '',
      clientEmail: apiLead.clientEmail || apiLead.clientemail || apiLead.client_email || '',
      clientPhone: apiLead.clientPhone || apiLead.clientphone || apiLead.client_phone || '',
      leadSource: apiLead.leadSource || apiLead.leadsource || apiLead.lead_source || '',
      leadStatus: apiLead.leadStatus === false || apiLead.leadstatus === false ? 'inactive' : 'active',
      leadType: (apiLead.leadType || apiLead.leadtype || 'cold') as 'cold' | 'warm' | 'hot',
      interestedCourse: apiLead.interestedCourse || apiLead.interestedcourse || apiLead.interested_course || '',
      preferredLocation: apiLead.preferredLocation || apiLead.preferredlocation || apiLead.preferred_location || '',
      budget: Number(apiLead.budget) || 0,
      preferredCollege1: apiLead.preferredCollege1 || apiLead.preferredcollege1 || '',
      preferredCollege2: apiLead.preferredCollege2 || apiLead.preferredcollege2 || '',
      preferredCollege3: apiLead.preferredCollege3 || apiLead.preferredcollege3 || '',
      followupTimeline: apiLead.followupTimeline || apiLead.followuptimeline || '',
      nextAction: apiLead.nextAction || apiLead.nextaction || '',
      lastRemarks: apiLead.lastRemarks || apiLead.lastremarks || '',
      bookingStatus: (apiLead.bookingStatus || apiLead.bookingstatus || 'pending') as 'confirmed' | 'pending' | 'cancelled',
      bookingType: apiLead.bookingType || apiLead.bookingtype || '',
      expectedDate: apiLead.expectedDate || apiLead.expecteddate || '',
      visitDate: apiLead.visitDate || apiLead.visitdate || apiLead.visit_data || '',
      employeeCode: apiLead.employeeCode || apiLead.employee_code || this.state.employeeCode,
    }));
    this.setState({ leads: transformedLeads, page: 0 });
  };

  fetchLeads = async () => {
    const { employeeCode } = this.state;
    const { GetLeadDetailsByEmployee, dispatch } = this.props;
    if (!employeeCode) return;
    try { await GetLeadDetailsByEmployee(employeeCode)(dispatch); }
    catch (error) { console.error('Error fetching leads:', error); }
  };

  handleEmployeeCodeChange = (newCode: string) => { this.setState({ employeeCode: newCode }); };
  handleEmployeeSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCode = event.target.value;
    this.setState({ employeeCode: selectedCode }, () => { this.fetchLeads(); });
  };
  handleFilterLeadNameChange = (e: React.ChangeEvent<HTMLInputElement>) => { this.setState({ filterLeadName: e.target.value, page: 0 }); };
  handleFilterInterestedCourseChange = (e: React.ChangeEvent<HTMLSelectElement>) => { this.setState({ filterInterestedCourse: e.target.value, page: 0 }); };
  handleFilterBookingStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => { this.setState({ filterBookingStatus: e.target.value, page: 0 }); };
  handleFilterLeadStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => { this.setState({ filterLeadStatus: e.target.value, page: 0 }); };
  handleFilterBookingTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => { this.setState({ filterBookingType: e.target.value, page: 0 }); };
  clearAllFilters = () => {
    this.setState({ filterLeadName: '', filterInterestedCourse: '', filterBookingStatus: '', filterLeadStatus: '', filterBookingType: '', search: '', page: 0 });
  };

  handleBookingTypeChange = async (lead: Lead, newBookingType: string) => {
    const { employeeCode } = this.state;
    const { AddLead, dispatch } = this.props;
    
    this.setState({ isSaving: true });
    
    try {
      const updateRequest: AddLeadRequest = {
        indicator: 'U',
        id: lead.leadId || lead.id,
        clientname: lead.clientName,
        clientparentname: lead.clientParentName,
        clientemail: lead.clientEmail,
        clientphone: lead.clientPhone,
        leadsource: lead.leadSource,
        leadstatus: lead.leadStatus === 'active',
        leadtype: lead.leadType,
        interestedcourse: lead.interestedCourse,
        preferredlocation: lead.preferredLocation,
        budget: lead.budget,
        preferredcollege1: lead.preferredCollege1,
        preferredcollege2: lead.preferredCollege2,
        preferredcollege3: lead.preferredCollege3,
        followuptimeline: lead.followupTimeline,
        nextaction: lead.nextAction,
        lastremarks: lead.lastRemarks,
        bookingstatus: lead.bookingStatus,
        bookingtype: newBookingType,
        expecteddate: lead.expectedDate,
        visitdate: lead.visitDate,
        employee_code: employeeCode,
      };
      
      const result = await AddLead(updateRequest)(dispatch);
      
      if (result?.success === true || result?.Success === true || result?.out_success === true) {
        const updatedLeads = this.state.leads.map(l => 
          l.id === lead.id ? { ...l, bookingType: newBookingType } : l
        );
        this.setState({ leads: updatedLeads });
        this.showToast('success', `Booking type updated to ${newBookingType}`);
      } else {
        this.showToast('error', 'Failed to update booking type');
      }
    } catch (error: any) {
      this.showToast('error', error?.message || 'Failed to update booking type');
    } finally {
      this.setState({ isSaving: false });
    }
  };

  get filtered() {
    const q = this.state.search.toLowerCase();
    const { filterLeadName, filterInterestedCourse, filterBookingStatus, filterLeadStatus, filterBookingType } = this.state;
    let list = this.state.leads.filter(l => {
      const matchesGlobal =
        (l.clientName?.toLowerCase() || '').includes(q) ||
        (l.clientParentName?.toLowerCase() || '').includes(q) ||
        (l.clientEmail?.toLowerCase() || '').includes(q) ||
        (l.clientPhone?.toLowerCase() || '').includes(q) ||
        (l.leadSource?.toLowerCase() || '').includes(q) ||
        (l.leadType?.toLowerCase() || '').includes(q) ||
        (l.interestedCourse?.toLowerCase() || '').includes(q) ||
        (l.preferredLocation?.toLowerCase() || '').includes(q) ||
        (l.bookingStatus?.toLowerCase() || '').includes(q) ||
        (l.bookingType?.toLowerCase() || '').includes(q) ||
        (l.lastRemarks?.toLowerCase() || '').includes(q);
      if (!matchesGlobal) return false;
      if (filterLeadName && !(l.clientName?.toLowerCase() || '').includes(filterLeadName.toLowerCase())) return false;
      if (filterInterestedCourse && l.interestedCourse !== filterInterestedCourse) return false;
      if (filterBookingStatus && l.bookingStatus !== filterBookingStatus) return false;
      if (filterLeadStatus && l.leadStatus !== filterLeadStatus) return false;
      if (filterBookingType && l.bookingType !== filterBookingType) return false;
      return true;
    });
    return [...list].sort((a, b) =>
      this.state.sortAsc
        ? (a.clientName || '').localeCompare(b.clientName || '')
        : (b.clientName || '').localeCompare(a.clientName || '')
    );
  }

  get paginated() {
    const { page, rowsPerPage } = this.state;
    return this.filtered.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
  }

  openAdd = () => { this.setState({ showModal: true, editingLead: null, form: { ...EMPTY_FORM } }); };
  openEdit = (lead: Lead) => {
    this.setState({
      showModal: true,
      editingLead: lead,
      form: {
        clientName: lead.clientName, clientParentName: lead.clientParentName,
        clientEmail: lead.clientEmail, clientPhone: lead.clientPhone,
        leadSource: lead.leadSource, leadStatus: lead.leadStatus, leadType: lead.leadType,
        interestedCourse: lead.interestedCourse, preferredLocation: lead.preferredLocation,
        budget: lead.budget, preferredCollege1: lead.preferredCollege1,
        preferredCollege2: lead.preferredCollege2, preferredCollege3: lead.preferredCollege3,
        followupTimeline: lead.followupTimeline, nextAction: lead.nextAction,
        lastRemarks: lead.lastRemarks, bookingStatus: lead.bookingStatus,
        bookingType: lead.bookingType, expectedDate: lead.expectedDate, visitDate: lead.visitDate,
      }
    });
  };
  closeModal = () => { this.setState({ showModal: false, isSaving: false, editingLead: null }); };
  handleFormChange = (field: keyof typeof EMPTY_FORM, value: string | number) => {
    this.setState(prev => ({ form: { ...prev.form, [field]: value } }));
  };

  handleSave = async () => {
    const { editingLead, form, employeeCode } = this.state;
    const { AddLead, dispatch } = this.props;
    if (!form.clientName ||  !form.clientPhone) {
      this.showToast('error', 'Client Name, and Phone are required fields.');
      return;
    }
    this.setState({ isSaving: true });
    try {
      const leadRequest: AddLeadRequest = {
        indicator: editingLead ? 'U' : 'I',
        id: editingLead ? (editingLead.leadId || editingLead.id) : null,
        clientname: form.clientName, clientparentname: form.clientParentName,
        clientemail: form.clientEmail, clientphone: form.clientPhone,
        leadsource: form.leadSource, leadstatus: form.leadStatus === 'active',
        leadtype: form.leadType, interestedcourse: form.interestedCourse,
        preferredlocation: form.preferredLocation, budget: form.budget,
        preferredcollege1: form.preferredCollege1, preferredcollege2: form.preferredCollege2,
        preferredcollege3: form.preferredCollege3, followuptimeline: form.followupTimeline,
        nextaction: form.nextAction, lastremarks: form.lastRemarks,
        bookingstatus: form.bookingStatus, bookingtype: form.bookingType,
        expecteddate: form.expectedDate, visitdate: form.visitDate,
        employee_code: employeeCode,
      };
      const result = await AddLead(leadRequest)(dispatch);
      if (result) {
        const isSuccess = result.success === true || result.Success === true || result.data?.Success === true || result.data?.success === true;
        if (isSuccess) {
          const apiMessage = result.message || result.Message || result.data?.Message || result.data?.message || (editingLead ? 'Lead updated successfully!' : 'Lead added successfully!');
          this.showToast('success', apiMessage);
          setTimeout(() => { this.setState({ showModal: false, isSaving: false }); }, 100);
          setTimeout(() => { this.fetchLeads(); }, 500);
        } else {
          const errorMessage = result.message || result.Message || result.data?.Message || result.data?.message || 'Operation failed';
          this.showToast('error', errorMessage);
          this.setState({ isSaving: false });
        }
      } else {
        this.showToast('success', editingLead ? 'Lead updated successfully!' : 'Lead added successfully!');
        setTimeout(() => { this.setState({ showModal: false, isSaving: false }); this.fetchLeads(); }, 500);
      }
    } catch (error: any) {
      this.showToast('error', error?.message || 'Failed to save lead');
      this.setState({ isSaving: false });
    }
  };

  handleDeleteClick = (lead: Lead) => { this.setState({ showDeleteConfirm: true, deletingLead: lead }); };
  handleDeleteCancel = () => { this.setState({ showDeleteConfirm: false, deletingLead: null }); };
  handleDeleteConfirm = async () => {
    const { deletingLead, employeeCode } = this.state;
    const { AddLead, dispatch } = this.props;
    if (!deletingLead) return;
    this.setState({ isDeleting: true });
    try {
      const deleteRequest: AddLeadRequest = {
        indicator: 'D', id: deletingLead.leadId || deletingLead.id,
        clientname: '', clientparentname: '', clientemail: '', clientphone: '',
        leadsource: '', leadstatus: false, leadtype: '', interestedcourse: '',
        preferredlocation: '', budget: 0, preferredcollege1: '', preferredcollege2: '',
        preferredcollege3: '', followuptimeline: '', nextaction: '', lastremarks: '',
        bookingstatus: '', bookingtype: '', expecteddate: '', visitdate: '',
        employee_code: employeeCode,
      };
      const result = await AddLead(deleteRequest)(dispatch);
      const isSuccess = result?.success === true || result?.Success === true || result?.out_success === true;
      const msg = result?.message || result?.Message || result?.out_message || (isSuccess ? 'Lead deleted successfully!' : 'Failed to delete lead');
      this.showToast(isSuccess ? 'success' : 'error', msg);
      this.setState({ showDeleteConfirm: false, deletingLead: null, isDeleting: false });
      if (isSuccess || !result) setTimeout(() => { this.fetchLeads(); }, 500);
    } catch (error: any) {
      this.showToast('error', error?.message || 'Failed to delete lead');
      this.setState({ showDeleteConfirm: false, deletingLead: null, isDeleting: false });
    }
  };

  typeBadgeClass = (t: string) => t === 'hot' ? 'lm-badge lm-type-hot' : t === 'warm' ? 'lm-badge lm-type-warm' : 'lm-badge lm-type-cold';
  typeEmoji = (t: string) => t === 'hot' ? '🔥' : t === 'warm' ? '☀️' : '❄️';
  bookingClass = (s: string) => s === 'confirmed' ? 'lm-badge lm-booking-confirmed' : s === 'cancelled' ? 'lm-badge lm-booking-cancelled' : 'lm-badge lm-booking-pending';
  bookingEmoji = (s: string) => s === 'confirmed' ? '✅' : s === 'cancelled' ? '❌' : '⏳';

  render() {
    const {
      search, page, rowsPerPage, sortAsc, showModal, editingLead, form, employeeCode,
      employeeInfo, employees, isSaving, isDeleting, showToast, toastMessage, toastType,
      showDeleteConfirm, deletingLead, roleCode,
      filterLeadName, filterInterestedCourse, filterBookingStatus, filterLeadStatus, filterBookingType,
    } = this.state;
    const { loading, error } = this.props;
    const filtered = this.filtered;
    const paginated = this.paginated;
    const totalPages = Math.ceil(filtered.length / rowsPerPage);
    const start = filtered.length > 0 ? page * rowsPerPage + 1 : 0;
    const end = Math.min((page + 1) * rowsPerPage, filtered.length);
    const isAdmin = roleCode === 'ADMIN';
    const hasActiveFilters = !!(filterLeadName || filterInterestedCourse || filterBookingStatus || filterLeadStatus || filterBookingType || search);

    // Determine if Expected Date or Visit Date should be disabled based on booking type
    const isBookingTypeDone = form.bookingType === 'done';
    const isBookingTypePending = form.bookingType === 'pending';

    return (
      <>
        <style>{globalStyles}</style>
        <div className="lm-page">
          {/* Background orbs */}
          <div style={{ position:'fixed',top:'5%',left:'8%',width:420,height:420,borderRadius:'50%',background:'radial-gradient(circle,rgba(0,160,155,.2) 0%,transparent 68%)',animation:'orbPulse1 11s ease-in-out infinite',pointerEvents:'none',zIndex:0 }} />
          <div style={{ position:'fixed',bottom:'8%',right:'6%',width:500,height:500,borderRadius:'50%',background:'radial-gradient(circle,rgba(0,120,175,.15) 0%,transparent 68%)',animation:'orbPulse2 15s ease-in-out infinite',pointerEvents:'none',zIndex:0 }} />
          <div className="lm-grid-bg" />
          {PARTICLES.map(p => (
            <div key={p.id} className="lm-particle" style={{ width:p.size,height:p.size,left:`${p.left}%`,bottom:-p.size,['--dur' as any]:`${p.dur}s`,['--delay' as any]:`${p.delay}s`,['--dx' as any]:`${p.dx}px` }} />
          ))}

          {/* Toast */}
          {showToast && (
            <div className={`lm-toast ${toastType}`}>
              <span style={{ fontSize:18 }}>{toastType === 'success' ? '✅' : '❌'}</span>
              <span style={{ flex:1 }}>{toastMessage}</span>
            </div>
          )}

          {/* Breadcrumb */}
          <div className="lm-breadcrumb">
            <span className="lm-breadcrumb-current">
              Lead Management — Edvisor
              {employeeInfo?.employeeName && ` — ${employeeInfo.employeeName}`}
              {loading && ' (Loading...)'}
            </span>
          </div>

          <div className="lm-content">

            {/* ── Employee Selector Bar ── */}
            <div style={{ marginBottom:20, display:'flex', gap:12, alignItems:'center', flexWrap:'wrap', background:'linear-gradient(90deg,rgba(0,40,50,.4) 0%,rgba(0,20,30,.6) 100%)', padding:'14px 18px', borderRadius:12, border:'1px solid rgba(0,210,200,.2)', backdropFilter:'blur(8px)' }}>
              {isAdmin && (
                <select
                  value={employeeCode}
                  onChange={this.handleEmployeeSelect}
                  style={{ width:420, background:'linear-gradient(160deg,#0c1c2d 0%,#071220 100%)', color:'#e8f4f6', border:'1px solid rgba(0,210,200,.4)', borderRadius:8, padding:'10px 14px', fontSize:14, cursor:'pointer', outline:'none', boxShadow:'0 4px 12px rgba(0,0,0,.4)', transition:'all .2s ease' }}
                  disabled={loading || isDeleting}
                >
                  <option value="">{employees.length === 0 ? 'Loading employees...' : 'Select an employee'}</option>
                  {employees.map(emp => (
                    <option key={emp.EmployeeCode} value={emp.EmployeeCode} style={{ background:'#0c1c2d', color:'#e8f4f6' }}>
                      {emp.EmployeeName} ({emp.EmployeeCode}) - {emp.Designation}
                    </option>
                  ))}
                </select>
              )}
              <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                <span style={{ color:'#7ab0b8', fontSize:13, fontWeight:500 }}>or</span>
                <input
                  type="text"
                  value={employeeCode}
                  onChange={e => this.handleEmployeeCodeChange(e.target.value)}
                  style={{ width:130, background:'linear-gradient(160deg,#0c1c2d 0%,#071220 100%)', color:'#e8f4f6', border:'1px solid rgba(0,210,200,.3)', borderRadius:8, padding:'10px 14px', fontSize:14, outline:'none', transition:'all .2s ease' }}
                  placeholder="Emp Code"
                />
              </div>
              <button
                onClick={() => this.fetchLeads()}
                disabled={loading || isDeleting}
                style={{ padding:'10px 22px', background:'linear-gradient(90deg,rgba(0,160,155,.3) 0%,rgba(0,120,175,.2) 100%)', border:'1px solid rgba(0,210,200,.4)', borderRadius:8, color:'#e8f4f6', fontSize:14, fontWeight:600, cursor:'pointer', display:'inline-flex', alignItems:'center', gap:8, transition:'all .2s ease', boxShadow:'0 4px 12px rgba(0,0,0,.3)', marginLeft:'auto' }}
              >
                <span style={{ fontSize:16 }}>🔄</span> Refresh
              </button>
            </div>

            {/* Employee Info Strip */}
            {employeeInfo && !error && (
              <div style={{ marginBottom:16, padding:'12px 18px', background:'linear-gradient(90deg,rgba(0,110,105,.2) 0%,rgba(0,160,155,.1) 100%)', borderRadius:8, border:'1px solid rgba(0,210,200,.25)', display:'flex', gap:30, fontSize:14, color:'#e8f4f6', flexWrap:'wrap', boxShadow:'inset 0 1px 0 rgba(0,210,200,.1)' }}>
                <span><strong style={{ color:'#00d2c8' }}>Name:</strong> {employeeInfo.employeeName}</span>
                <span><strong style={{ color:'#00d2c8' }}>Department:</strong> {employeeInfo.department}</span>
                <span><strong style={{ color:'#00d2c8' }}>Designation:</strong> {employeeInfo.designation}</span>
              </div>
            )}

            {/* Connection Error Banner */}
            {error && error.message && error.message.includes('connect') && (
              <div style={{ marginBottom:16, padding:'12px 18px', background:'rgba(180,40,40,.15)', border:'1px solid rgba(180,40,40,.3)', borderRadius:8, color:'#ff6b6b', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <span><strong>Connection Error:</strong> Failed to connect to server. Please make sure the backend is running.</span>
                <button onClick={() => this.fetchLeads()} style={{ padding:'6px 14px', background:'rgba(255,255,255,.1)', border:'1px solid rgba(255,255,255,.2)', borderRadius:6, color:'#fff', cursor:'pointer', fontSize:13 }}>Retry</button>
              </div>
            )}

            {/* ── Main Section ── */}
            <div className="lm-section">
              <div className="lm-shimmer-line" />
              <div className="lm-section-header">
                <span className="lm-section-title">Lead Management{loading && ' — Loading...'}</span>
                <span style={{ fontSize:12, color:'#7ab0b8', fontWeight:500 }}>{filtered.length} lead{filtered.length !== 1 ? 's' : ''}{hasActiveFilters ? ' (filtered)' : ''}</span>
              </div>

              <div className="lm-section-body">

                {/* Toolbar */}
                <div className="lm-toolbar">
                  <button className="lm-add-btn" onClick={this.openAdd} disabled={isSaving || isDeleting}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 5v14M5 12h14"/></svg>
                    Add Lead
                  </button>
                  <div className="lm-search-wrap">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2a7070" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
                    <input
                      className="lm-search-input"
                      placeholder="Search by name, email, phone, course..."
                      value={search}
                      onChange={e => this.setState({ search: e.target.value, page: 0 })}
                    />
                    {search && (
                      <button onClick={() => this.setState({ search:'', page:0 })} style={{ background:'none', border:'none', cursor:'pointer', color:'#2a7070', padding:0, lineHeight:1, fontSize:14 }}>✕</button>
                    )}
                  </div>
                </div>

                {/* ── Filter Bar ── */}
                <div className="lm-filter-bar">
                  <div className="lm-filter-group">
                    <label className="lm-filter-label">Lead Name</label>
                    <input
                      type="text"
                      className="lm-filter-input"
                      placeholder="Search by name..."
                      value={filterLeadName}
                      onChange={this.handleFilterLeadNameChange}
                    />
                  </div>

                  <div className="lm-filter-group">
                    <label className="lm-filter-label">Interested Course</label>
                    <select
                      className="lm-filter-select"
                      value={filterInterestedCourse}
                      onChange={this.handleFilterInterestedCourseChange}
                    >
                      <option value="">All Courses</option>
                      {COURSES.map(course => <option key={course} value={course}>{course}</option>)}
                    </select>
                  </div>

                  <div className="lm-filter-group">
                    <label className="lm-filter-label">Booking Status</label>
                    <select
                      className="lm-filter-select"
                      value={filterBookingStatus}
                      onChange={this.handleFilterBookingStatusChange}
                    >
                      <option value="">All Statuses</option>
                      <option value="confirmed">✅ Confirmed</option>
                      <option value="pending">⏳ Pending</option>
                      <option value="cancelled">❌ Cancelled</option>
                    </select>
                  </div>

                  <div className="lm-filter-group">
                    <label className="lm-filter-label">Booking Type</label>
                    <select
                      className="lm-filter-select"
                      value={filterBookingType}
                      onChange={this.handleFilterBookingTypeChange}
                    >
                      <option value="">All Types</option>
                      <option value="done">✅ Done</option>
                      <option value="pending">⏳ Pending</option>
                    </select>
                  </div>

                  <div className="lm-filter-group">
                    <label className="lm-filter-label">Lead Status</label>
                    <select
                      className="lm-filter-select"
                      value={filterLeadStatus}
                      onChange={this.handleFilterLeadStatusChange}
                    >
                      <option value="">All Statuses</option>
                      <option value="active">✅ Active</option>
                      <option value="inactive">❌ Inactive</option>
                    </select>
                  </div>

                  <button
                    className="lm-clear-filters"
                    onClick={this.clearAllFilters}
                    disabled={!hasActiveFilters}
                  >
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M6 18L18 6M6 6l12 12"/></svg>
                    Clear
                  </button>
                </div>

                {/* Table */}
                <div className="lm-table-wrap">
                  <table className="lm-table">
                    <thead>
                      <tr>
                        <th style={{ width: 80 }}>Actions</th>
                        <th className="sortable" onClick={() => this.setState(p => ({ sortAsc: !p.sortAsc, page: 0 }))}>
                          Client Info <span className="lm-sort-icon">{sortAsc ? '↑' : '↓'}</span>
                        </th>
                        <th>Parent Name</th>
                        <th>Lead Source</th>
                        <th>Lead Status</th>
                        <th>Lead Type</th>
                        <th>Interested Course</th>
                        <th>Pref. Location</th>
                        <th>Budget (₹)</th>
                        <th>Preferred Colleges</th>
                        <th>Followup Timeline</th>
                        <th>Next Action</th>
                        <th>Last Remarks</th>
                        <th>Booking Status</th>
                        <th>Booking Type</th>
                        <th>Dynamic Data<br/>(Done→Date | Pending→Visit)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr><td colSpan={16} style={{ textAlign:'center', padding:40, color:'#2a7070' }}>Loading leads...</td></tr>
                      ) : error && error.message && error.message.includes('connect') ? (
                        <tr><td colSpan={16} style={{ textAlign:'center', padding:40, color:'#ff6b6b' }}>Failed to connect to server.</td></tr>
                      ) : paginated.length > 0 ? (
                        paginated.map((l, i) => (
                          <tr key={l.id} className="lm-trow" style={{ animationDelay: `${i * 40}ms` }}>
                            <td>
                              <div style={{ display:'flex', gap:5 }}>
                                <button className="lm-icon-btn" onClick={() => this.openEdit(l)} title="Edit" disabled={isSaving || isDeleting}>
                                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                                </button>
                                <button className="lm-icon-btn del" onClick={() => this.handleDeleteClick(l)} title="Delete" disabled={isSaving || isDeleting}>
                                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>
                                </button>
                              </div>
                            </td>
                            <td>
                              <div style={{ fontWeight:700, color:'#0b2d30', fontSize:12, whiteSpace:'nowrap' }}>{l.clientName}</div>
                              <div style={{ color:'#2a7070', fontSize:10.5 }}>{l.clientEmail}</div>
                              <div style={{ color:'#2a7070', fontSize:10.5 }}>{l.clientPhone}</div>
                            </td>
                            <td><div style={{ fontWeight:600, color:'#1a5558', fontSize:11, whiteSpace:'nowrap' }}>{l.clientParentName || '—'}</div></td>
                            <td><span className="lm-badge" style={{ borderColor:'rgba(0,100,150,.4)', color:'#003a5e' }}>{l.leadSource || '—'}</span></td>
                            <td>
                              <div style={{ display:'flex', alignItems:'center', gap:5 }}>
                                <span style={{ fontSize:13 }}>{l.leadStatus === 'active' ? '✅' : '❌'}</span>
                                <span className={`lm-badge lm-status-${l.leadStatus}`}>{l.leadStatus}</span>
                              </div>
                            </td>
                            <td>
                              <span className={this.typeBadgeClass(l.leadType)}>
                                {this.typeEmoji(l.leadType)} {l.leadType.charAt(0).toUpperCase() + l.leadType.slice(1)}
                              </span>
                            </td>
                            <td style={{ fontWeight:600, color:'#005e5a', whiteSpace:'nowrap' }}>{l.interestedCourse || '—'}</td>
                            <td style={{ color:'#1a5558', fontWeight:600, whiteSpace:'nowrap' }}>{l.preferredLocation || '—'}</td>
                            <td style={{ fontWeight:700, color:'#003f5c', whiteSpace:'nowrap' }}>₹{(l.budget || 0).toLocaleString('en-IN')}</td>
                            <td>
                              <div style={{ display:'flex', flexDirection:'column', gap:2, fontSize:10.5 }}>
                                <div><span style={{ fontWeight:700, color:'#1a5558' }}>1.</span> {l.preferredCollege1 || '—'}</div>
                                <div><span style={{ fontWeight:700, color:'#1a5558' }}>2.</span> {l.preferredCollege2 || '—'}</div>
                                <div><span style={{ fontWeight:700, color:'#1a5558' }}>3.</span> {l.preferredCollege3 || '—'}</div>
                              </div>
                            </td>
                            <td style={{ fontWeight:600, color:'#3a5a00', fontSize:11, whiteSpace:'nowrap' }}>{l.followupTimeline || '—'}</td>
                            <td style={{ maxWidth:160, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', color:'#2a7070', fontSize:11 }}>{l.nextAction || '—'}</td>
                            <td style={{ maxWidth:160, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', color:'#2a7070', fontSize:11 }}>{l.lastRemarks || '—'}</td>
                            <td>
                              <div style={{ display:'flex', alignItems:'center', gap:5 }}>
                                <span style={{ fontSize:13 }}>{this.bookingEmoji(l.bookingStatus)}</span>
                                <span className={this.bookingClass(l.bookingStatus)}>{l.bookingStatus.charAt(0).toUpperCase() + l.bookingStatus.slice(1)}</span>
                              </div>
                            </td>
                            <td>
                              <select
                                className="lm-filter-input"
                                value={l.bookingType || 'pending'}
                                onChange={(e) => this.handleBookingTypeChange(l, e.target.value)}
                                style={{ width: '100px', padding: '4px 8px', fontSize: '11px' }}
                                disabled={isSaving || isDeleting}
                              >
                                <option value="pending">⏳ Pending</option>
                                <option value="done">✅ Done</option>
                              </select>
                            </td>
                            <td>
                              {l.bookingType === 'done' ? (
                                <div className="dynamic-data-done">
                                  📅 {l.expectedDate ? new Date(l.expectedDate).toLocaleDateString('en-IN') : 'Date not set'}
                                </div>
                              ) : (
                                <div className="dynamic-data-pending">
                                  📅 {l.visitDate ? new Date(l.visitDate).toLocaleDateString('en-IN') : 'Date not set'}
                                </div>
                              )}
                             </td>
                           </tr>
                        ))
                      ) : (
                        <tr><td colSpan={16} style={{ textAlign:'center', padding:40, color:'#2a7070' }}>No leads found. Click "Add Lead" to create one.</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {filtered.length > 0 && !error && (
                  <div className="lm-pagination">
                    <span style={{ fontSize:11, marginRight:4 }}>Showing {start}–{end} of {filtered.length}</span>
                    <span>Rows:</span>
                    <select className="lm-pg-select" value={rowsPerPage} onChange={e => this.setState({ rowsPerPage:Number(e.target.value), page:0 })}>
                      {[5,10,20,50].map(n => <option key={n} value={n}>{n}</option>)}
                    </select>
                    <button className="lm-action-btn" disabled={page === 0} onClick={() => this.setState(p => ({ page:p.page - 1 }))}>◀</button>
                    {Array.from({ length:Math.min(totalPages, 5) }, (_,i) => (
                      <button key={i} className="lm-action-btn" style={{ background:page===i ? 'rgba(0,110,105,.28)':undefined, fontWeight:page===i ? 700:600 }} onClick={() => this.setState({ page:i })}>
                        {i + 1}
                      </button>
                    ))}
                    <button className="lm-action-btn" disabled={page >= totalPages - 1} onClick={() => this.setState(p => ({ page:p.page + 1 }))}>▶</button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* ── Delete Confirm Modal ── */}
          {showDeleteConfirm && deletingLead && (
            <div className="lm-overlay" onClick={this.handleDeleteCancel}>
              <div className="lm-modal" style={{ width:400 }} onClick={e => e.stopPropagation()}>
                <div className="lm-shimmer-line" />
                <div className="lm-modal-header">
                  <span className="lm-modal-title">🗑️ Confirm Delete</span>
                  <button className="lm-icon-btn" onClick={this.handleDeleteCancel} disabled={isDeleting}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>
                  </button>
                </div>
                <div className="lm-modal-body">
                  <div className="lm-delete-confirm">
                    <p>Are you sure you want to delete the lead for <strong>{deletingLead.clientName}</strong>?</p>
                    <p style={{ fontSize:11, color:'#7a1010' }}>This action cannot be undone.</p>
                    <div className="lm-delete-confirm-buttons">
                      <button className="lm-cancel-delete-btn" onClick={this.handleDeleteCancel} disabled={isDeleting}>Cancel</button>
                      <button className="lm-confirm-delete-btn" onClick={this.handleDeleteConfirm} disabled={isDeleting}>{isDeleting ? 'Deleting...' : 'Yes, Delete'}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ── Add / Edit Modal ── */}
          {showModal && (
            <div className="lm-overlay" onClick={this.closeModal}>
              <div className="lm-modal" onClick={e => e.stopPropagation()}>
                <div className="lm-shimmer-line" />
                <div className="lm-modal-header">
                  <span className="lm-modal-title">{editingLead ? '✏️ Edit Lead' : '➕ Add Lead'}</span>
                  <button className="lm-icon-btn" onClick={this.closeModal} disabled={isSaving}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>
                  </button>
                </div>

                <div className="lm-modal-body">
                  <div className="lm-form-row">
                    <label className="lm-label">Client Name *</label>
                    <input className="lm-input" value={form.clientName} onChange={e => this.handleFormChange('clientName', e.target.value)} placeholder="Full name" disabled={isSaving} required />
                  </div>
                  <div className="lm-form-row">
                    <label className="lm-label">Parent / Guardian Name</label>
                    <input className="lm-input" value={form.clientParentName} onChange={e => this.handleFormChange('clientParentName', e.target.value)} placeholder="Parent's full name" disabled={isSaving} />
                  </div>
                  <div className="lm-form-grid">
                    <div className="lm-form-row">
                      <label className="lm-label">Email *</label>
                      <input className="lm-input" type="email" value={form.clientEmail} onChange={e => this.handleFormChange('clientEmail', e.target.value)} placeholder="email@example.com" disabled={isSaving} required />
                    </div>
                    <div className="lm-form-row">
                      <label className="lm-label">Phone *</label>
                      <input className="lm-input" value={form.clientPhone} onChange={e => this.handleFormChange('clientPhone', e.target.value)} placeholder="+91 00000 00000" disabled={isSaving} required />
                    </div>
                  </div>
                  <div className="lm-form-grid">
                    <div className="lm-form-row">
                      <label className="lm-label">Lead Source</label>
                      <select className="lm-input" value={form.leadSource} onChange={e => this.handleFormChange('leadSource', e.target.value)} disabled={isSaving}>
                        <option value="">Select source</option>
                        {LEAD_SOURCES.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                    <div className="lm-form-row">
                      <label className="lm-label">Lead Status</label>
                      <select className="lm-input" value={form.leadStatus} onChange={e => this.handleFormChange('leadStatus', e.target.value)} disabled={isSaving}>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="lm-form-grid">
                    <div className="lm-form-row">
                      <label className="lm-label">Lead Type</label>
                      <select className="lm-input" value={form.leadType} onChange={e => this.handleFormChange('leadType', e.target.value)} disabled={isSaving}>
                        <option value="cold">❄️ Cold</option>
                        <option value="warm">☀️ Warm</option>
                        <option value="hot">🔥 Hot</option>
                      </select>
                    </div>
                    <div className="lm-form-row">
                      <label className="lm-label">Booking Status</label>
                      <select className="lm-input" value={form.bookingStatus} onChange={e => this.handleFormChange('bookingStatus', e.target.value)} disabled={isSaving}>
                        <option value="pending">⏳ Pending</option>
                        <option value="confirmed">✅ Confirmed</option>
                        <option value="cancelled">❌ Cancelled</option>
                      </select>
                    </div>
                  </div>
                  <div className="lm-form-grid-3">
                    <div className="lm-form-row">
                      <label className="lm-label">Booking Type</label>
                      <select 
                        className="lm-input" 
                        value={form.bookingType} 
                        onChange={e => {
                          this.handleFormChange('bookingType', e.target.value);
                          // Auto-clear the opposite field when switching
                          if (e.target.value === 'done') {
                            this.handleFormChange('visitDate', '');
                          } else if (e.target.value === 'pending') {
                            this.handleFormChange('expectedDate', '');
                          }
                        }} 
                        disabled={isSaving}
                      >
                        <option value="pending">⏳ Pending</option>
                        <option value="done">✅ Done</option>
                      </select>
                    </div>
                    <div className="lm-form-row">
                      <label className="lm-label">Expected Date</label>
                      <input 
                        className={`lm-input ${!isBookingTypeDone ? 'disabled-field' : ''}`} 
                        type="date" 
                        value={form.expectedDate} 
                        onChange={e => this.handleFormChange('expectedDate', e.target.value)} 
                        disabled={isSaving || !isBookingTypeDone}
                      />
                    </div>
                    <div className="lm-form-row">
                      <label className="lm-label">Visit Date</label>
                      <input 
                        className={`lm-input ${!isBookingTypePending ? 'disabled-field' : ''}`} 
                        type="date" 
                        value={form.visitDate} 
                        onChange={e => this.handleFormChange('visitDate', e.target.value)} 
                        disabled={isSaving || !isBookingTypePending}
                      />
                    </div>
                  </div>
                  <div className="lm-form-grid">
                    <div className="lm-form-row">
                      <label className="lm-label">Interested Course</label>
                      <select className="lm-input" value={form.interestedCourse} onChange={e => this.handleFormChange('interestedCourse', e.target.value)} disabled={isSaving}>
                        <option value="">Select course</option>
                        {COURSES.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                    <div className="lm-form-row">
                      <label className="lm-label">Preferred Location</label>
                      <input className="lm-input" type="text" value={form.preferredLocation} onChange={e => this.handleFormChange('preferredLocation', e.target.value)} placeholder="Enter preferred location" disabled={isSaving} />
                    </div>
                  </div>
                  <div className="lm-form-row">
                    <label className="lm-label">Budget (₹)</label>
                    <input className="lm-input" type="number" value={form.budget} onChange={e => this.handleFormChange('budget', Number(e.target.value))} placeholder="e.g. 1500000" disabled={isSaving} />
                  </div>
                  <div className="lm-form-row">
                    <label className="lm-label">Preferred Colleges</label>
                    {(['preferredCollege1','preferredCollege2','preferredCollege3'] as const).map((field, idx) => (
                      <div key={field} className="lm-college-row">
                        <span className="lm-college-num">{idx + 1}.</span>
                        <input className="lm-input" style={{ flex:1 }} type="text" value={form[field]} onChange={e => this.handleFormChange(field, e.target.value)} placeholder={`College ${idx + 1}`} disabled={isSaving} />
                      </div>
                    ))}
                  </div>
                  <div className="lm-form-grid">
                    <div className="lm-form-row">
                      <label className="lm-label">Followup Timeline</label>
                      <input className="lm-input" type="date" value={form.followupTimeline} onChange={e => this.handleFormChange('followupTimeline', e.target.value)} disabled={isSaving} />
                    </div>
                    <div className="lm-form-row">
                      <label className="lm-label">Next Action</label>
                      <input className="lm-input" value={form.nextAction} onChange={e => this.handleFormChange('nextAction', e.target.value)} placeholder="e.g. Schedule counselling call" disabled={isSaving} />
                    </div>
                  </div>
                  <div className="lm-form-row">
                    <label className="lm-label">Last Remarks</label>
                    <textarea className="lm-input" value={form.lastRemarks} onChange={e => this.handleFormChange('lastRemarks', e.target.value)} placeholder="Add remarks about this lead..." disabled={isSaving} rows={3} />
                  </div>
                </div>

                <div className="lm-modal-footer">
                  <button className="lm-cancel-btn" onClick={this.closeModal} disabled={isSaving}>Cancel</button>
                  <button className="lm-save-btn" onClick={this.handleSave} disabled={isSaving}>
                    {isSaving ? 'Saving...' : (editingLead ? 'Update Lead' : 'Add Lead')}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  leads: state.lead?.records || state.lead?.leads || state.lead?.data || [],
  employeeInfo: state.lead?.employeeInfo || null,
  employees: state.lead?.employees || [],
  loading: state.lead?.loading || false,
  error: state.lead?.error || null,
  manageStatus: state.lead?.manageStatus || null,
});

const mapDispatchToProps = (dispatch: any) => ({
  GetLeadDetailsByEmployee: bindActionCreators(GetLeadDetailsByEmployee, dispatch),
  AddLead: bindActionCreators(AddLead, dispatch),
  ResetAddLead: bindActionCreators(ResetAddLead, dispatch),
  ClearLeadError: bindActionCreators(ClearLeadError, dispatch),
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(LeadManagementPage);